import React from 'react';

export default function PhotoViewer({ fileType, filePath }){
  return <img src={filePath } alt={filePath} width='100%' height='100%' ></img>
}